import InteriorThree from "../images/InteriorThree.jpg";
import PortraitThree from "../images/PortraitThree.jpg";

export const InfoData = {
    heading: "Explore our beautiful homes!",
    paragraphOne: "Our portfolio of more than 1,200 luxury villas encompasses the very best of the Europe with properties from Italy to Greece, Spain, and beyond. Whether you’re looking for Villa in Europe or a sprawling seaside estate for the whole family, we have it all.",
    paragraphTwo: "The villas are traditional but luxurious giving one a sense of traditional lifestyle whilst simultaneously keeping you cool in the heart of design and modern comfort. Olympic length infinity pool, private cinema, Jacuzzi, SPA, tennis court and helipad embrace you with the feeling of having arrived somewhere very special.",
    buttonLabel: "View Homes",
    image: InteriorThree,
    reverse: false,
    delay: 100,
};

export const InfoDataTwo = {
    heading: "Modern Designs",
    paragraphOne: "Open designs With abundant natural light, are descended from international architectural styles.",
    paragraphTwo: "Many of our villa's come with social and versatile living space with wide sliding doors between circulation zones and an open plan living and dining room. A majority of the social spaces are designated to the middle/main floor with private areas distributed between the lower floor.",
    buttonLabel: "View Homes",
    image: PortraitThree,
    reverse: false,
    delay: 300,
};